import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import auditTrailService from '../../../services/auditTrailService';

const AuditExportOptions = ({ filters }) => {
  const [exportFormat, setExportFormat] = useState('csv');
  const [isExporting, setIsExporting] = useState(false);

  const formatOptions = [
    { value: 'csv', label: 'CSV Spreadsheet' },
    { value: 'json', label: 'JSON Data' }
  ];

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const content = await auditTrailService?.exportAuditTrail(filters, exportFormat);
      
      const timestamp = new Date()?.toISOString()?.split('T')?.[0];
      const filename = `audit-trail-${timestamp}.${exportFormat}`;
      const mimeType = exportFormat === 'csv' ? 'text/csv' : 'application/json';
      
      auditTrailService?.downloadFile(content, filename, mimeType);
    } catch (error) {
      alert(`Export failed: ${error?.message}`);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Download" size={20} color="var(--color-primary)" />
        <h3 className="font-heading font-semibold text-foreground">Export Options</h3>
      </div>

      <Select
        label="Export Format"
        options={formatOptions}
        value={exportFormat}
        onChange={setExportFormat}
        className="mb-4"
      />

      <Button
        variant="default"
        size="default"
        onClick={handleExport}
        loading={isExporting}
        iconName="FileDown"
        iconPosition="left"
        fullWidth
      >
        Export Audit Trail
      </Button>

      <div className="mt-4 p-3 bg-muted rounded-md">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={16} color="var(--color-primary)" className="mt-0.5" />
          <div>
            <p className="caption text-xs text-foreground font-medium mb-1">
              Export Information
            </p>
            <p className="caption text-xs text-muted-foreground">
              Export includes all audit entries matching current filters. CSV format is recommended for Excel analysis.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditExportOptions;